import { BaseCreateComponent } from "./BaseCreateComponent";
import { historyBackManager } from "../services/historyBackManager";

export interface ConfirmDialogOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

export class ConfirmDialogComponent extends BaseCreateComponent<HTMLDivElement> {
  private _options: ConfirmDialogOptions;

  constructor(options: ConfirmDialogOptions) {
    super();
    this._options = options;
  }

  protected getTagName(): string { return "div"; }
  protected getElementId(): string { return "confirmDialogOverlay"; }
  protected getCssClassList(): string[] { return ["confirm-overlay"]; }

  private _backHandler = () => {
    this._options.onCancel?.();
    const el = this.getElement();
    el.classList.add("exit");
    setTimeout(() => super.dispose(), 180);
  };

  public override dispose(): void {
    historyBackManager.remove(this._backHandler);
    const el = this.getElement();
    el.classList.add("exit");
    setTimeout(() => super.dispose(), 180);
  }

  protected override afterInit(el: HTMLDivElement): void {
    historyBackManager.push(this._backHandler);
    const { title, message, confirmLabel = "Eliminar", cancelLabel = "Cancelar" } = this._options;

    el.innerHTML = `
      <div class="confirm-dialog">
        <div class="confirm-header">
          <span class="confirm-title">${title}</span>
        </div>
        <div class="confirm-body">
          <p class="confirm-message">${message}</p>
        </div>
        <div class="confirm-footer">
          <button class="confirm-btn-cancel">${cancelLabel}</button>
          <button class="confirm-btn-confirm">${confirmLabel}</button>
        </div>
      </div>
    `;

    el.querySelector<HTMLButtonElement>(".confirm-btn-cancel")!.onclick = () => {
      this._options.onCancel?.();
      this.dispose();
    };

    el.querySelector<HTMLButtonElement>(".confirm-btn-confirm")!.onclick = () => {
      this.dispose();
      this._options.onConfirm();
    };

    el.onclick = (e) => {
      if (e.target === el) {
        this._options.onCancel?.();
        this.dispose();
      }
    };
  }
}
